import React, {useEffect, useState } from "react";
import {  getPublicJobOpening, applyForJob } from "../../utils/helper";
import Loader from "../../utils/Loader";
import { useParams } from "react-router-dom";
import { alertError, alertSuccess, } from "../../utils/alerts";
 import logo from "../../assets/img/kr-logo.png";

const INIT_STATE = {
    jobTitle: "",
    jobType: "",
    job_level: "",
    end_date: "",
    employee_team:"",
    employee: "",
    relief_officer:"",
    createdAt:"",
    status: "",
};

const INIT_APP = {
    name: "",
    email: "",
    phone: "",
    address: "",
    country: "",
    cv:"",
    linkedin: "",
    portfolio:"",
};

export default function ViewJobOpening() {
    const { id } = useParams();
    const [loading, setLoading] = useState(true);
    const [state, setState] = useState(INIT_STATE);
    const [job, setJobOpening] = useState(null);
    const [view, setView] = useState(true);
    const [application, setApplication] = useState(INIT_APP);

    useEffect(() => {
        if(id){
            getPublicJobOpening(id)
                .then((res) => {
                    if(res.data.success){
                        setJobOpening(res.data.data);
                    }else {
                        alertError(res.data.message);
                    }
                })
                .catch((err) => {
                    console.log(err?.response?.data?.error)
                });
        }
        setLoading(false);
    }, [id]); 

    useEffect(() => {
        setState((prev) => ({
            ...prev,
            jobTitle: (job && job.jobTitle ) || "",
            jobType: (job && job.jobType ) || "",
            industry: (job && job.industry) || "",
            location: (job && job.location) || "",
            jobDescription: (job && job.jobDescription) || "",
            jobSummary: (job && job.jobSummary) || "",
            currency: (job && job.currency) || "",
            monthly_salary: (job && job.monthly_salary) || "",
            negotiable: (job && job.negotiable) || "",
            days_online: (job && job.days_online) || "",
            available_openings: (job && job.available_openings) || "",
            status: (job && job.status) || "",
            min_qualification: (job && job.min_qualification) || "",
            experience_length: (job && job.experience_length) || "",
            job_level: (job && job.job_level) || "",
        }));
    }, [job]);

    const handleChange = (e) => {
        e.persist();
        setApplication((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    }

    const handleChangeView = (e) => {
        e.preventDefault();
        setView((prev) => !prev );
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        const data = {
            ...application, job_id: id
        };
        
        if(data.name && data.job_id && data.email && data.cv && data.phone && data.address && data.linkedin && data.portfolio){
            applyForJob(data)
            .then((res)=> {
                // console.log(res.data)
                if(res.data.success){
                    alertSuccess(res.data.message);
                    setApplication(INIT_APP);
                }else {
                    alertError(res.data.message);
                }
                
            }).catch(err => {
                console.log(err.response.data.message)
                alertError(err.response?.data.message);
            })   
        }
    };

    return (
        <>  
            <section className="quotes">
                <div className="public">
                    <div className="layer">
                        <div className="text-center">
                            <img src={logo} className="" alt="logo" width={150} height={40} />
                        </div>

                        {(state && state.jobTitle) ? <>
                            <div className="container">
                                <div className="row">
                                    <div className="col-md-2"></div>
                                    <div className="col-md-8 text-center text-capitalize">
                                        <h3>{state && state.jobTitle} - {state && state.location}</h3>
                                        <button type="button" onClick={handleChangeView} className="btn">
                                            {view && view === true ? "I'm interested" : "View Job Details"}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </> : null }

                    </div>
                </div>

                <div className="container">
                    <div className="row">
                        <div className="col-md-12 text-left">
                            {(!loading && state && state.jobTitle) ? <>
                                {view && view === true ? <>
                                <div className="container d-flex">
                                    <div className="card profile-box flex-fill mt-3 mb-4" style={{width: 640}}>
                                        <div className="card-body">
                                            <h3 className="card-title" style={{fontSize: 20, fontWeight:'bold', marginBottom: 20, 
                                                borderBottom:'1px solid #ccc', paddingBottom: 20}}>
                                                Job Details 
                                            </h3>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <ul className="personal-info">
                                                        <li>
                                                            <div className="title">Job Title:</div>
                                                            <div className="text">{state.jobTitle && state.jobTitle}</div>
                                                        </li>
                                                        <li>
                                                            <div className="title">Job Level:</div>
                                                            <div className="text">{state.job_level && state.job_level}</div>
                                                        </li>
                                                        <li>
                                                            <div className="title">Job Type:</div>
                                                            <div className="text">{state.jobType && state.jobType}</div>
                                                        </li>
                                                        <li>
                                                            <div className="title">Industry:</div>
                                                            <div className="text"><span>{state.industry && state.industry} </span></div>
                                                        </li>
                                                        <li>
                                                            <div className="title">Location:</div>
                                                            <div className="text">{state.location && state.location}</div>
                                                        </li>
                                                        
                                                        
                                                    </ul>
                                                </div>
                                                <div className="col-md-6">
                                                    <ul className="personal-info">
                                                        <li>
                                                            <div className="title">Monthly Salary:</div>
                                                            <div className="text">{state.currency && state.currency} <span>{state.monthly_salary && state.monthly_salary} </span></div>
                                                        </li>
                                                        <li>
                                                            <div className="title">Is Salary negotiable?:</div>
                                                            <div className="text">{state.negotiable && state.negotiable}</div>
                                                        </li>
                                                        <li>
                                                            <div className="title">Available Openings:</div>
                                                            <div className="text">{state.available_openings && state.available_openings}</div>
                                                        </li>
                                                        <li>
                                                            <div className="title">Minimum Qualification:</div>
                                                            <div className="text">{state.min_qualification && state.min_qualification} </div>
                                                        </li>
                                                        <li>
                                                            <div className="title">Experience Length:</div>
                                                            <div className="text">{state.experience_length && state.experience_length}</div>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div className="col-md-12">
                                                    <ul className="personal-info">
                                                        <li>
                                                            <div className="title">Job Summary:</div>
                                                            <div className="text">{state.jobSummary && state.jobSummary}</div>
                                                        </li>
                                                        <li>
                                                            <div className="title">Job Description /  Requirements:</div>
                                                            <div className="text">{state.jobDescription && state.jobDescription}</div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                </> : <>

                                <div className="container d-flex">
                                    <div className="card profile-box flex-fill mt-3 mb-4" style={{width: 640}}>
                                        <div className="card-body">
                                            <h3 className="card-title" style={{fontSize: 20, fontWeight:'bold', marginBottom: 20, borderBottom:'1px solid #ccc', paddingBottom: 20}}>
                                                Apply for Job  
                                            </h3>
                                            <form method="post" encType="multipart/form-data" onSubmit={handleSubmit}>
                                                <div className="row">
                                                    <div className="col-md-6 col-sm-12 col-xs-12 form-group">
                                                        <label className="control-label">Full Name: <span>*</span></label>
                                                        <input name="name"  type="text" placeholder="Full Name" className="form-control" required 
                                                        onChange={handleChange} defaultValue={application.name || ""}/>
                                                    </div>
                                                    <div className="col-md-6 col-sm-12 col-xs-12 form-group">
                                                        <label className="control-label">Email Address: <span>*</span></label>
                                                        <input name="email" type="email" placeholder="Email Address" className="form-control" required 
                                                        onChange={handleChange} defaultValue={application.email || ""}/>
                                                    </div>
                                                    <div className="col-md-6 col-sm-12 col-xs-12 form-group">
                                                        <label className="control-label">Phone Number: <span>*</span></label>
                                                        <input name="phone" type="tel" placeholder="Phone Number" className="form-control" required 
                                                        onChange={handleChange} defaultValue={application.phone || ""}/>
                                                    </div>
                                                    <div className="col-md-6 col-sm-12 col-xs-12 form-group">
                                                        <label className="control-label">City: <span>*</span></label>
                                                        <input name="address" type="text" placeholder="City" className="form-control" required 
                                                        onChange={handleChange} defaultValue={application.address || ""}/>
                                                    </div>
                                                    <div className="col-md-6 col-sm-12 col-xs-12 form-group">
                                                        <label className="control-label">Country: <span>*</span></label>
                                                        <input name="country" type="text" placeholder="Country" className="form-control" required 
                                                        onChange={handleChange} defaultValue={application.country || ""}/>
                                                    </div>

                                                    <div className="col-md-6 col-sm-12 col-xs-12 form-group">
                                                        <label className="control-label">Link to CV: <span>*</span></label>
                                                        <input name="cv" type="text" placeholder="Link to CV" className="form-control" required 
                                                        onChange={handleChange} defaultValue={application.cv || ""}/>
                                                    </div>

                                                    <div className="col-md-6 col-sm-12 col-xs-12 form-group">
                                                        <label className="control-label">Link to LinkedIn profile: <span>*</span></label>
                                                        <input name="linkedin" type="text" placeholder="Link to LinkedIn profile" className="form-control" required 
                                                        onChange={handleChange} defaultValue={application.linkedin || ""}/>
                                                    </div>

                                                    <div className="col-md-6 col-sm-12 col-xs-12 form-group">
                                                        <label className="control-label">Link to Portfolio: <span>*</span></label>
                                                        <input name="portfolio" type="text" placeholder="Link to Portfolio" className="form-control" required 
                                                        onChange={handleChange} defaultValue={application.portfolio || ""}/>
                                                    </div>
                                                    
                                                </div>
                                                <div className="row form-group">
                                                    <div className="col-md-12 col-sm-12 text-center">
                                                        <button 
                                                            type="submit" 
                                                            disabled={loading}
                                                            className="btn btn-primary" 
                                                            onClick={() => handleSubmit}
                                                        >
                                                            {loading ? <i className="fa fa-spinner fa-spin"></i> : "Submit Application" }
                                                        </button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div> 
                            </> }


                            </> : <Loader /> }

                        </div>
                    </div>

                </div>
            </section>

            <div className="publicjobsfooter">
                <p>Powered by Kimberly Ryan Limited</p>
            </div>
        </>
    );
}
